import HookManager from '../../core/scripts/hook-manager.js';
import Swiper from 'swiper';

HookManager.hook('wakefly/swiper_init', (carousel, config, container) => {
  if (container.classList.contains('product-portfolio-carousel')) {
    container.closest('.wf-block-product-portfolio').querySelectorAll('.portfolio-section-control').forEach((elem) => {
      elem.addEventListener('click', (evt) => {
        evt.preventDefault();
        carousel.slideToLoop(parseInt(elem.getAttribute('data-start')));
        return false;
      })
    })
    carousel.on('slideChange', () => {
      container.closest('.wf-block-product-portfolio').querySelectorAll('.portfolio-section-control').forEach((elem) => {
        elem.classList.toggle('active', parseInt(elem.getAttribute('data-start')) <= carousel.realIndex && parseInt(elem.getAttribute('data-end')) > carousel.realIndex);
      })
    });
  }
  return config;
});